<!-- 招聘详情 -->
<template>
  <div class="container">
    <login-navigator></login-navigator>
    <logo-header></logo-header>
    <main-navigator :currentIndex="navid"></main-navigator>
    <section class="bread">
        <span class="index">首页</span><span>&gt;</span><span class="current">{{navList[curIndex].name}}</span>
    </section>
    <section class="main">
        <div class="main-content">
            <div class="left">
                <img :src="desObject.thumb_img !=null?desObject.thumb_img:imgBig[curIndex].path" alt="">
            </div>
            <div class="right">
                <h3>{{desObject.title}}</h3>
                <p class="price">{{desObject.price}}</p>
                <p class="recruit">{{desObject.address}}</p>
                <p class="recruit">联系电话:{{desObject.phone}}</p>
                <!-- <p><span class="tag" v-for="item in desObject.tags">{{item}}</span></p> -->
                <p class="limit">{{desObject.limit}}</p>
                <div class="enroll-wrap"><button class="enroll">报名</button></div>
            </div>
        </div>
        <div class="des">
            <h3>职位描述</h3> 
        </div>
        <div id="des-wrap" class="des-wrap">
          {{desObject.dec}}
        </div>
    </section>
  </div>
</template>

<script>
import qs from "qs";
import LoginNavigator from "../components/LoginNavigator";
import LogoHeader from "../components/LogoHeader";
import Bread from "../components/Bread";
import MainNavigator from "../components/MainNavigator";
export default {
  data() {
    return {
      desObject: {},
      listIndex: 0,
      curIndex: 0,
      navid: 0,
      navList: [],
      imgBig: [
        {
          path: require("../assets/1b.png")
        },
        {
          path: require("../assets/2b.png")
        },
        {
          path: require("../assets/15b.png")
        },
        {
          path: require("../assets/16b.png")
        },
        {
          path: require("../assets/17b.png")
        },
        {
          path: require("../assets/18b.png")
        },
        {
          path: require("../assets/19b.png")
        },
        {
          path: require("../assets/20b.png")
        },
        {
          path: require("../assets/21b.png")
        },
        {
          path: require("../assets/22b.png")
        }
      ]
    };
  },
  components: {
    Bread,
    LoginNavigator,
    LogoHeader,
    MainNavigator
  },
  created() {
    this.listIndex = parseInt(this.$route.query.id);
    console.log("cur", this.$route.query);
    this.navid = parseInt(this.$route.query.navid);
    this.curIndex = parseInt(this.$route.query.navindex);
  },
  mounted() {
    this.getNavList();
  },
  methods: {
    getNavList: function() {
      let that = this;
      that.$axios
        .post(
          "http://imgurl120.moontion.cn/cyy/wy/employ/index.php/Employ/getParentCateInfo"
        )
        .then(res => {
          if (res.data.success) {
            console.log("detail", res.data);
            var list = res.data.info;
            that.navList = list;
            that.getInfoId();
          }
        });
    },
    getInfoId: function() {
      var that = this,
        id = this.listIndex;
      var postData = {
        id: id
      };
      that.$axios
        .post(
          "http://imgurl120.moontion.cn/cyy/wy/employ/index.php/Employ/getInfoId",
          qs.stringify(postData)
        )
        .then(function(res) {
          that.desObject = res.data.info;
        });
    }
  }
};
</script>
<style scoped>
.container {
  width: 100%;
  background: #f5f5f5;
}
.bread {
  width: 1200px;
  height: 57px;
  line-height: 57px;
  margin: 0 auto;
  background: #fff;
}
.bread .index {
  margin-left: 24px;
}
.bread span {
  font-size: 12px;
  color: #333;
}
.bread .current {
  color: #00a0e9;
}
.main {
  width: 1200px;
  padding-top: 9px;
  margin: 0 auto;
  background: #fff;
}
.main .main-content {
  display: flex;
  flex-direction: row;
}
.main .main-content .left {
}
.main .main-content .left img {
  display: inline-block;
  width: 500px;
  height: 384px;
  background: #edebeb;
}
.main .main-content .right {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 18px 10px 27px 26px;
  width: 100%;
}
.main .main-content .right h3 {
  font-size: 20px;
  color: #666;
  margin-bottom: 30px;
}
.main .main-content .right .price {
  color: #ff7e00;
  font-size: 24px;
  margin-bottom: 20px;
}
.main .main-content .right .recruit {
  font-size: 14px;
  color: #b3b3b3;
  margin-bottom: 22px;
}
.main .main-content .right .tag {
  font-size: 11px;
  color: #c2c8cc;
  background: #f2f4f5;
  padding: 5px 11px 4px 12px;
  margin-right: 12px;
}
.main .main-content .right .limit {
  margin-top: 40px;
  color: #333;
  font-size: 30px;
  font-weight: 500;
}
.main .main-content .right .enroll-wrap {
  width: 100%;
  text-align: right;
}
.main .main-content .right .enroll-wrap .enroll {
  display: inline-block;
  background: #00a0e9;
  color: #fff;
  width: 180px;
  height: 46px;
  font-size: 18px;
  line-height: 46px;
  text-align: center;
  border: none;
  margin: 79px 110px 0 0;
}
.main .des {
  margin-top: 45px;
  padding: 0 29px 30px 25px;
}
.main .des h3 {
  font-size: 18px;
  color: #333;
  border-left: 6px solid #00a0e9;
  padding-left: 9px;
  margin-bottom: 31px;
}
.main #des-wrap {
  padding: 0 50px 50px 50px;
  line-height: 25px;
}
</style>


// WEBPACK FOOTER //
// src/views/detail.vue